import { Box, Flex, SimpleGrid, Stack } from '@chakra-ui/react';
import React from 'react';

import { TextField } from 'Containers/App/types';
import { ProviderCard } from 'Containers/ResultPage/ProviderSelectionContent/ProviderCard';
import { Icon, IconTypes, Paragraph } from 'DesignLibrary/atoms';
import { StackedIcon } from 'Shared/StackedIcon';
import Text from 'Shared/Text';
import { ProviderSectionProps } from 'Types/entities';

export const ProviderSection = ({
  networkType,
  providers,
  isMostPreferredEnabled,
  mostPreferredProviderName,
}: ProviderSectionProps) => {
  const providersCount = providers!.length;

  const getProviderHeader = () => {
    let iconColor = '--text-gray';
    let iconShape: IconTypes | undefined;
    let textFieldName: TextField;

    if (networkType === 'preferred-network') {
      iconColor = providersCount > 0 ? '--colors-alex-blue' : '--text-gray';
      iconShape = 'Star';
      textFieldName = 'health_section.compare_plan_text.compareModal.preferredNetwork';
    } else if (networkType === 'in-network') {
      iconColor = providersCount > 0 ? '--primary-green' : '--text-gray';
      iconShape = 'CheckCircle';
      textFieldName = 'health_section.compare_plan_text.compareModal.inNetwork';
    } else {
      iconColor = providersCount > 0 ? '--primary-red' : '--text-gray';
      iconShape = 'XCircle';
      textFieldName = 'health_section.compare_plan_text.compareModal.outOfNetwork';
    }

    const headingText = (
      <Paragraph
        size="small"
        as="h5"
        weight="bold"
        color={providersCount > 0 ? '--text-black' : '--text-gray'}
        data-testid="network-text"
      >
        {isMostPreferredEnabled && mostPreferredProviderName ? (
          mostPreferredProviderName
        ) : (
          <Text field={textFieldName} />
        )}
      </Paragraph>
    );

    if (networkType === 'preferred-network') {
      const starIcon = <Icon type={iconShape} size="small" color="--primary-white" weight="fill" />;

      return (
        <Flex align="center" gap={2}>
          <StackedIcon
            circleArgs={{ color: iconColor, size: 'normal', weight: 'fill' }}
            dataTestId="preferred-network-docs-icon"
            stackedIcon={starIcon}
          />
          {headingText}
        </Flex>
      );
    }

    return (
      <Flex align="center" gap={2}>
        <Icon color={iconColor} type={iconShape} />
        {headingText}
      </Flex>
    );
  };

  return (
    <Stack gap={1}>
      {getProviderHeader()}
      <SimpleGrid columns={[1, 2]} gap={2}>
        {providersCount > 0 &&
          providers?.map((provider, index) => (
            <ProviderCard
              showIcon={false}
              title={`${provider.first_name} ${provider.middle_name ? `${provider.middle_name} ` : ''}${provider.last_name}`.trim()}
              subtitle={provider.provider_types?.join(', ')}
              key={provider.npi}
              testId={`${networkType}-view-plan-${index}`}
            />
          ))}

        {providersCount === 0 && (
          <Box p={3} borderRadius="var(--border-radius-xs)" bg="var(--background-gray)">
            <Paragraph size="small" weight="bold" data-testid={`${networkType}-view-plan-none`}>
              <Text field="health_section.recommendation.in_network_providers_none" />
            </Paragraph>
          </Box>
        )}
      </SimpleGrid>
    </Stack>
  );
};
